import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLgroupIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 0.000115696H10C9.54 0.000115696 9.14 0.310116 9.03 0.760116L6.72 10.0001H1C0.45 10.0001 0 10.4501 0 11.0001V13.0001C0 13.5501 0.45 14.0001 1 14.0001H5.72L3.53 22.7601C3.36 23.3701 3.87 24.0201 4.5 24.0001H17.5C17.96 24.0001 18.36 23.6901 18.47 23.2401L23.97 1.24012C24.14 0.630116 23.63 -0.0098843 23 0.000115696ZM16.72 22.0001H5.78L7.78 14.0001H11V15.7501C10.97 16.5601 12 17.0601 12.62 16.5401L17.37 12.7901C17.87 12.4101 17.87 11.6001 17.37 11.2201L12.62 7.47012C12 6.95012 10.97 7.44012 11 8.25012V10.0001H8.78L10.78 2.00012H21.72L16.72 22.0001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLgroupIcon.displayName = 'HierLgroupIcon';
